<template>
  <div class="i-datetime-picker">
    <el-date-picker
      ref="datePickerRef"
      v-model="inputVal"
      type="datetime"
      format="dd-MM-yyyy HH:mm"
      value-format="dd-MM-yyyy HH:mm"
      placeholder="dd-MM-yyyy HH:mm"
      :clearable="false"
      :disabled="disabled"
      size="small"
      :picker-options="pickerOptions"
      class="date-picker"
      @input.native="inputValue"
    />
  </div>
</template>
<script>
export default {
  name: 'DateTimePicker',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pickerOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      inputVal: this.value
    }
  },
  watch: {
    inputVal: function(val) {
      if (val !== this.value) {
        this.$emit('input', val)
      }
    },
    value: function(val) {
      if (val !== this.inputVal) {
        this.inputVal = val
      }
    }
  },
  methods: {
    inputValue(dom) {
      let value = dom.target.value
      let str = value.replace(/[^\d]/g, '')
      let len = str.length
      let result = ''
      if (len >= 12) {
        result = `${str.slice(0, 2)}-${str.slice(2, 4)}-${str.slice(4, 8)} ${str.slice(8, 10)}:${str.slice(10, len)}`
        this.inputVal = result
        this.$refs['datePickerRef'].userInput = result // 輸入完直接替換
      }

    }
  }
}
</script>
<style lang="scss" scoped>
.i-datetime-picker {
  width: 100%;
  .el-date-editor.el-input {
    width: 100%;
  }
}
</style>

